import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useJsonLd } from "@/hooks/useJsonLd";

// Below-the-fold sections are code-split so the initial render only ships Navbar + Hero.
const Systems = lazy(() => import("@/components/Systems"));
const ImpactStats = lazy(() => import("@/components/ImpactStats"));
const Calculator = lazy(() => import("@/components/Calculator"));
const Partners = lazy(() => import("@/components/Partners"));
const Articles = lazy(() => import("@/components/Articles"));
const CTA = lazy(() => import("@/components/CTA"));
const Footer = lazy(() => import("@/components/Footer"));

const SectionFallback = () => <div className="min-h-[40vh]" />;

const Index = () => {
  useDocumentTitle(
    undefined,
    "Dynamic LED grow lights and Synthia™ control software helping greenhouses and vertical farms grow more with less energy.",
  );
  useJsonLd({
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Photosynthetic",
    url: "https://www.photosynthetic.com/",
    publisher: { "@type": "Organization", name: "Photosynthetic" },
  });
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <Hero />
        <Suspense fallback={<SectionFallback />}>
          <ImpactStats />
          <Systems />
          <Partners />
          <Calculator />
          <Articles />
          <CTA />
        </Suspense>
      </main>
      <Suspense fallback={<SectionFallback />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
